/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components), {Box, WarningIconImg, Link} = _components;
  if (!Box) _missingMdxReference("Box", true);
  if (!Link) _missingMdxReference("Link", true);
  if (!WarningIconImg) _missingMdxReference("WarningIconImg", true);
  return React.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    bgcolor: "#fef1d2",
    height: "40px",
    padding: "1.5em",
    mt: "1em",
    mb: "1em"
  }, React.createElement(WarningIconImg), React.createElement(Box, {
    fontSize: "caption.fontSize",
    m: {
      sm: 0.5,
      md: 1
    }
  }, React.createElement(_components.p, null, "Due to the current lapse of federal appropriations: this website may not be up to date; transactions submitted via this website might not be processed until appropriations are enacted; and we may not be able to respond to inquiries until appropriations are enacted. For more information, please visit The Department of the Interior shutdown page at: ", React.createElement(Link, {
    href: "https://www.doi.gov/shutdown",
    target: "_blank"
  }, "https://www.doi.gov/shutdown", React.createElement(OpenInNewIcon, {
    style: {
      fontSize: 12
    }
  })))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
